import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Input from 'components/common/Input';
import { Card, Col, OverlayTrigger, ToggleButton, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFormContext } from 'react-hook-form';
import Flex from 'components/common/Flex';
import { changeToCoin, changeToNumber } from 'helpers/utils';

const ProductPricing = ({ article }) => {
 const {
  watch,
  register,
  setValue,
  formState: { errors }
 } = useFormContext();

 const selts = watch('priceMethod') ?? '';
 const price = watch('regularPrice') ?? '';

 const [select, setSelect] = useState('');
 const [amount, setAmount] = useState('');
 const [options, setOptions] = useState([]);
 const [radioValue, setRadioValue] = useState('cantidad');

 const onChange = ({ target: { value } }) =>
  setValue('regularPrice', changeToNumber({ amount: value, cents: true }), { shouldValidate: true });

 useEffect(() => {
  setAmount(changeToCoin({ amount: price, symbol: true, cents: true }));
 }, [price]);

 useEffect(() => {
  setSelect(options?.find(e => e.value === selts) ?? '');
 }, [selts]);

 useEffect(() => {
  setOptions(article?.references.map(e => ({ value: e.reference, label: e.reference })));
  setValue('priceMethod', article?.references.find(e => e.reference === selts)?.reference ?? '');
 }, [article]);

 return (
  <Card className="mb-3">
   <Card.Body>
    <Flex className="g-2" direction="row" justifyContent="start" alignItems="center" wrap="wrap">
     <Col md={3} className="flex-grow-1 text-truncate pe-2 border-end border-end-2 me-2 me-md-0">
      <OverlayTrigger
       overlay={
        <Tooltip style={{ position: 'fixed' }} id="finalPriceTooltip">
         Product final price
        </Tooltip>
       }
      >
       <span className="d-flex text-primary fs-0">
        <FontAwesomeIcon icon="question-circle" />
        <h5 className="ms-1 mb-0 fs-0">Precio</h5>
       </span>
      </OverlayTrigger>

      <p className="m-0 fs--2 text-muted">Cantidad | Referencia</p>
     </Col>

     <Col md={3} className="d-flex justify-content-end px-md-2">
      <ToggleButton
       id={`radio-${1}`}
       type="radio"
       variant="falcon-primary"
       name="radio"
       value="cantidad"
       className="px-2 px-md-3 m-0 me-2"
       checked={radioValue === 'cantidad'}
       onChange={e => setRadioValue(e.currentTarget.value)}
      >
       Ctd.
      </ToggleButton>
      <ToggleButton
       id={`radio-${2}`}
       type="radio"
       variant="falcon-primary"
       name="radio"
       value="referencia"
       className="px-2 px-md-3 m-0"
       checked={radioValue === 'referencia' && article?.code}
       disabled={true} //{!article?.code}
       onChange={e => setRadioValue(e.currentTarget.value)}
      >
       Ref.
      </ToggleButton>
     </Col>

     {radioValue === 'cantidad' ? (
      <Input
       type="text"
       name="quantity"
       errors={errors}
       placeholder="Cantidad"
       formGroupProps={{ as: Col, xs: 6, md: 3, className: 'mt-3 mt-md-0 fs--1' }}
       formControlProps={{
        ...register(`quantity`, { required: true, validate: value => (!isNaN(value) && parseFloat(value) > 0) || 'Debe ser > 0' })
       }}
      />
     ) : (
      <Input
       type="selectMulti"
       name="priceMethod"
       errors={errors}
       placeholder="Seleccione..."
       options={options}
       formGroupProps={{ className: 'mt-3 mt-md-0' }}
       formControlProps={{
        isClearable: false,
        isMulti: false,
        closeMenuOnSelect: true,
        value: select,
        onChange: newValue => setValue('priceMethod', newValue.value, { shouldValidate: true })
       }}
      />
     )}

     <Input
      type="text"
      errors={errors}
      name="regularPrice"
      help={{ title: 'Precio', body: 'Precio regular del producto' }}
      placeholder="Precio Base"
      formGroupProps={{ as: Col, xs: 6, md: 3, className: 'ps-2 mt-3 mt-md-0 fs--1' }}
      formControlProps={{ value: amount, onChange, onFocus: e => e.target.select() }}
     />

     <Input
      type="hidden"
      formControlProps={{
       ...register('regularPrice', {
        required: true,
        validate: value => (!isNaN(value) && parseFloat(value) > 0) || 'Debe ser > 0'
       })
      }}
     />
    </Flex>
   </Card.Body>
  </Card>
 );
};

ProductPricing.propTypes = {
 article: PropTypes.object
};

export default ProductPricing;
